import { track as vercelTrack } from '@vercel/analytics';

export function track(event, props) {
  try {
    vercelTrack(event, props);
  } catch (e) {
    // analytics must never break the app
  }
}
